module.exports = __webpack_public_path__ + "static/media/p1gif.8991c43b.gif";